module.exports = __webpack_public_path__ + "static/media/tgLogo.0f65f2f2.png";